import { authAxios} from "../config";
import { ApiKey } from "../endpoints";
 
export const GetMasterTechnologies  = async () => {
  try {
   
    const res = await authAxios.get(`${ApiKey.GetMasterTech}`);
     return res.data;
 
  } catch (err) {
     return err;
  }
};
 
 
export const postArticle = async (finalData) => {
  try {
    const res = await authAxios.post(`${ApiKey.postArticle}`, finalData);
    console.log(res,"data")
    return res.data;
   
  }
  catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
  }
};

// export const GetAllArticle = async () =>{
//   try{
//       var response = await authAxios.get(`${ApiKey.getAllArticle}`);
//       return response.data;
//   }
//   catch(err){
//   return err;
//   }
// };

export const PaginatedArticle = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.PaginatedArticle}`, data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}

export const EditArticleDetail = async (data) => {
  try{
const res = await authAxios.post(`${ApiKey.editArticle}`, data);
    console.log(res,"data")
    return res.data;
   
  }
  catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
}
};

export const DeleteArticleDetail = async (articleId) => {
  try{
const res = await authAxios.post(`${ApiKey.deleteArticle}`, articleId);
    console.log(res,"data")
    return res.data;
  
  }
  catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
}
};


export const SetVisibilityArticle = async (articleId) => {
  try{
const res = await authAxios.post(`${ApiKey.setVisibilityArticle}`, articleId);
    console.log(res,"data")
    return res.data;
  
  }
  catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
}
};

export const ChangeUserArticleStatus = async(data) => {
try{
const res = await authAxios.post(`${ApiKey.changeStatus}`, data);
    console.log(res,"data")
    return res.data;
}
catch(err){
let error = err.response.data;
    console.error(error);
    return error;
}
}
export const GetArticle = async (reqData) => {
  try {
    const res = await authAxios.post(`${ApiKey.GetSingleArticle}`, reqData);
    return res.data;
   
  } 
  catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
  }
};